import React from 'react';

import Styled from 'styled';
import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';

import Select, { Props as SelectProps } from 'four-nets/ui-v2/form/select/select';

import { PostVisibility } from 'four-nets/photoblog/create-post/mutations/create-post.graphql.types';

import Options from './options';
import defaultStyles from './visibility-select.scss';

export const StyledSelect = (props: Omit<SelectProps, 'styles'>) => (
    <Select
        style={{
            icon: defaultStyles.icon,
            container: defaultStyles.container,
            select: defaultStyles.select,
            element: defaultStyles.element,
            label: defaultStyles.label,
        }}
        {...props}
    />
);

export { StyledSelect as Select };

export interface Props {
    styles: typeof defaultStyles;

    value: PostVisibility;
    name: string;
    onBlur: (e: any) => void;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

class VisibilitySelect extends React.PureComponent<Props> {
    render() {
        const { value, name, onBlur, onChange } = this.props;
        const styles = this.props.styles!;

        return (
            <Options value={value}>
                {(options, src) => (
                    <StyledSelect
                        beforeElement={<SVGIcon src={src} className={styles.lockIcon} />}
                        name={name}
                        value={value}
                        onBlur={onBlur}
                        onChange={onChange}
                        multiple={false}
                    >
                        {options}
                    </StyledSelect>
                )}
            </Options>
        );
    }
}

export default Styled(defaultStyles)(VisibilitySelect);
